var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page --check-compatibility" }, [
    _c("div", { staticClass: "content" }, [
      _c("h1", [
        _vm._v(
          _vm._s(_vm.__("Bluehost Site Migrator", "bluehost-site-migrator"))
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [
          _vm._v(
            _vm._s(
              _vm.__("Let's get this truck rolling:", "bluehost-site-migrator")
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.__(
              "A website compatibility check needs to be performed before the",
              "bluehost-site-migrator"
            )
          )
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.__(
              "transfer process can begin to verify that your website can be transferred.",
              "bluehost-site-migrator"
            )
          )
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.__("transferred.", "bluehost-site-migrator"))),
      ]),
      _vm._v(" "),
      _c(
        "button",
        { class: this.buttonClasses, on: { click: _vm.checkCompatibility } },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.__("Check Compatibility", "bluehost-site-migrator")) +
              "\n      "
          ),
          _c("spinner", {
            attrs: {
              color: "white",
              "is-visible": this.isSpinnerVisible,
              size: "18",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "message" }, [_vm._v(_vm._s(_vm.message))]),
    ]),
    _vm._v(" "),
    _c("img", { attrs: { src: _vm.imageSrc } }),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }